export const FLIGHT_TICKET_ISSUE_METADATA = {
  categories: [
    { code: 'provider_extraction', name: 'AI extraction', color: '#E85C20' },
    { code: 'direction_classification', name: 'Direction classification', color: '#F0C427' },
    { code: 'client_data_mismatch', name: 'Client data mismatch', color: '#DD4E4E' },
    { code: 'other', name: 'Other', color: '#718198' },
  ],
  states: [
    { code: 'open', name: 'Open', color: '#E85C20' },
    { code: 'resolved', name: 'Resolved', color: '#77B017' },
    { code: 'dismissed', name: 'Dismissed', color: '#718198' },
  ],
  directions: [
    { code: 'arrival', name: 'Arrival' },
    { code: 'departure', name: 'Departure' },
  ],
}

export function getFlightTicketIssueMetadata() {
  return {
    categories: FLIGHT_TICKET_ISSUE_METADATA.categories.map(item => ({ ...item })),
    states: FLIGHT_TICKET_ISSUE_METADATA.states.map(item => ({ ...item })),
    directions: FLIGHT_TICKET_ISSUE_METADATA.directions.map(item => ({ ...item })),
  }
}

